module.exports = __webpack_public_path__ + "img/IMG_20190123_113504.28944423.jpg";